import React, { useState } from "react";
import MainToolbar from "../MainToolbar";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  makeStyles,
  IconButton,
  Paper,
} from "@material-ui/core";
import t from "../common/localization";
import { useEffectAsync } from "../reactHelper";
import EditCollectionView from "../EditCollectionView";
import { formatBoolean, formatPosition } from "../common/formatter";
import EditIcon from "@material-ui/icons/Edit";
import ClearIcon from "@material-ui/icons/Clear";
import { green, blue, red, grey } from "@material-ui/core/colors";
import Avatar from "@material-ui/core/Avatar";
import { showLoaderStateActions } from "./../store";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "material-ui-search-bar";

const useStyles = makeStyles((theme) => ({
  columnAction: {
    width: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  tableAction: {
    backgroundColor: "white",
  },
  rowAction: {
    backgroundColor: "#361DDB",
  },
  iconButtons: {
    marginLeft: "auto",
    display: "flex",
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "#EFEFEF",
    margin: "2px",
  },
  tCell: {
    color: "white",
    backgroundColor: "#361DDB",
  },
  tContainer: {
    maxHeight: 730,
  },
}));

const VendorsView = ({
  updateTimestamp,
  onMenuClick,
  handleOnEdit,
  handleOnRemove,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [successDialogShow, setSuccessDialogShow] = useState(false);

  const [items, setItems] = useState([]);
  const [searchList, setSearchList] = useState([]);

  useEffectAsync(async () => {
    dispatch(showLoaderStateActions.addState(true));

    const response = await fetch("/api/vendors");
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      const res = await response.json();
      setItems(res);
      setSearchList(res);
    }
  }, [updateTimestamp]);

  const searchChange = (val) => {
    const newItems = items.filter((current) => {
      const { name, email, helpline, distributor } = current;
      let checkval = `${name || ""}${email || ""}${helpline || ""}${distributor || ""}`;
      checkval = checkval.toLowerCase();
      return checkval.includes(val && val.toLowerCase());
    });

    setSearchList(newItems);
  };

  const reset = () => {
    console.log("val");
  };
  const filterItems = searchList.sort(
    (a, b) =>
      new Date(b.creationTime).getTime() - new Date(a.creationTime).getTime(),
  );

  return (
    <>
      <SearchBar
        // value= {'search'}
        onChange={searchChange}
        onCancelSearch={reset}
        placeholder="Search here..."
        className="searchBarInput"
        style={{
          borderRadius: 15,
          height: 35,
          boxShadow: "2px 2px 2px 2px #dbddef",
          fontSize: 12,
          marginBottom: "10px",
          width: "300px",
        }}
        // onRequestSearch={() => doSomethingWith()}
      />
      <TableContainer className={classes.tContainer} component={Paper}>
        <Table
          stickyHeader
          aria-label="sticky table"
          className={classes.tableAction}
          size="small"
          style={{ whiteSpace: "nowrap" }}
        >
          <TableHead>
            <TableRow className={classes.rowAction}>
              <TableCell className={classes.tCell}>{t("sharedName")}</TableCell>
              <TableCell className={classes.tCell}>{t("userEmail")}</TableCell>
              <TableCell className={classes.tCell}>{t("address")}</TableCell>
              <TableCell className={classes.tCell}>{t("helpline")}</TableCell>
              <TableCell className={classes.tCell}>{t("website")}</TableCell>
              <TableCell className={classes.tCell}>{t("banner")}</TableCell>
              <TableCell className={classes.tCell}>{t("logo")}</TableCell>
              <TableCell className={classes.tCell}>{t("tagline")}</TableCell>
              <TableCell className={classes.tCell}>{t("iosLink")}</TableCell>
              <TableCell className={classes.tCell}>{t("androidLink")}</TableCell>
              <TableCell className={classes.tCell}>{t("webLink")}</TableCell>
              <TableCell className={classes.tCell}>
                {t("distributor")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("accountEmail")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("creationTime")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportRemarks")}
              </TableCell>
              <TableCell className={classes.tCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {filterItems.map((item) => (
              <TableRow hover key={item.id} className={classes.tableRow}>
                <TableCell>{<b>{item.name}</b>}</TableCell>
                <TableCell>{item.email}</TableCell>
                <TableCell>{item.address}</TableCell>
                <TableCell>{item.helpline}</TableCell>
                <TableCell>{item.website}</TableCell>
                <TableCell>{item.banner}</TableCell>
                <TableCell>{item.logo}</TableCell>
                <TableCell>{item.tagline}</TableCell>
                <TableCell>{item.iosLink}</TableCell>
                <TableCell>{item.androidLink}</TableCell>
                <TableCell>{item.webLink}</TableCell>
                <TableCell>{item.distributor}</TableCell>
                <TableCell>{item.accountEmail}</TableCell>
                <TableCell>{item.creationTime}</TableCell>
                <TableCell>{item.remarks}</TableCell>
                <TableCell className={classes.columnAction} padding="none">
                  <div className={classes.iconButtons}>
                    <Avatar className={classes.small}>
                      {
                        <IconButton onClick={(event) => handleOnEdit(item.id)}>
                          <EditIcon
                            fontSize="small"
                            style={{ color: blue[600] }}
                          />
                        </IconButton>
                      }
                    </Avatar>
                    <Avatar className={classes.small}>
                      {
                        <IconButton
                          onClick={(event) => handleOnRemove(item.id)}
                        >
                          <ClearIcon
                            fontSize="small"
                            style={{ color: grey[450] }}
                          />
                        </IconButton>
                      }
                    </Avatar>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

const VendorsPage = () => {
  return (
    <>
      <MainToolbar />
      <EditCollectionView
        content={VendorsView}
        editPath="/vendors"
        endpoint="vendors"
        successDialogShow={false}
      />
    </>
  );
};

export default VendorsPage;
